import { HoldOrdersRestoreActions } from '../@types/holdOrdersRestore';

export const loadHoldOrderChangesData = (newData: number[]) => dispatch => {
    return  dispatch({ type: HoldOrdersRestoreActions.LOAD_HOLD_ORDERS_CHANGES_DATA, payload: newData });
}